(function () {
  "use strict";

  var FOOTER_CLASS = "cab-v2-filter-footer";

  /** CAB: jRange slider increments (theme `step`); Min/Max inputs accept any numeric value within min/max (no $100 snap). */
  var CAB_PRICE_STEP = 100;

  /** Close icon — stroked X for adjustable line weight. */
  var CAB_CLOSE_SVG =
    '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
    '<path stroke="#111111" stroke-width="1.5" stroke-linecap="round" d="M3.5 3.5 10.5 10.5M10.5 3.5 3.5 10.5"/>' +
    "</svg>";

  /** Material info trigger beside Material facet title */
  var CAB_MATERIAL_INFO_SVG =
    '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
    '<path d="M6 10H7.33333V6H6V10ZM7.14167 4.475C7.26944 4.34722 7.33333 4.18889 7.33333 4C7.33333 3.81111 7.26944 3.65278 7.14167 3.525C7.01389 3.39722 6.85556 3.33333 6.66667 3.33333C6.47778 3.33333 6.31944 3.39722 6.19167 3.525C6.06389 3.65278 6 3.81111 6 4C6 4.18889 6.06389 4.34722 6.19167 4.475C6.31944 4.60278 6.47778 4.66667 6.66667 4.66667C6.85556 4.66667 7.01389 4.60278 7.14167 4.475ZM6.66667 13.3333C5.74444 13.3333 4.87778 13.1583 4.06667 12.8083C3.25556 12.4583 2.55 11.9833 1.95 11.3833C1.35 10.7833 0.875 10.0778 0.525 9.26667C0.175 8.45555 0 7.58889 0 6.66667C0 5.74444 0.175 4.87778 0.525 4.06667C0.875 3.25556 1.35 2.55 1.95 1.95C2.55 1.35 3.25556 0.875 4.06667 0.525C4.87778 0.175 5.74444 0 6.66667 0C7.58889 0 8.45555 0.175 9.26667 0.525C10.0778 0.875 10.7833 1.35 11.3833 1.95C11.9833 2.55 12.4583 3.25556 12.8083 4.06667C13.1583 4.87778 13.3333 5.74444 13.3333 6.66667C13.3333 7.58889 13.1583 8.45555 12.8083 9.26667C12.4583 10.0778 11.9833 10.7833 11.3833 11.3833C10.7833 11.9833 10.0778 12.4583 9.26667 12.8083C8.45555 13.1583 7.58889 13.3333 6.66667 13.3333ZM6.66667 12C8.15555 12 9.41667 11.4833 10.45 10.45C11.4833 9.41667 12 8.15555 12 6.66667C12 5.17778 11.4833 3.91667 10.45 2.88333C9.41667 1.85 8.15555 1.33333 6.66667 1.33333C5.17778 1.33333 3.91667 1.85 2.88333 2.88333C1.85 3.91667 1.33333 5.17778 1.33333 6.66667C1.33333 8.15555 1.85 9.41667 2.88333 10.45C3.91667 11.4833 5.17778 12 6.66667 12Z" fill="currentColor"/>' +
    "</svg>";

  function replaceCloseIcon() {
    var btn = document.querySelector(".sidebar_tags .close-btn-allfilter");
    if (!btn) return;
    btn.querySelectorAll("svg").forEach(function (s) {
      s.remove();
    });
    btn.insertAdjacentHTML("afterbegin", CAB_CLOSE_SVG);
  }


  /** Strip `sidebar-hidden` from jRange container so theme `{ .sidebar-hidden: display:none }` never hides the track */
  function ensureSliderVisible() {
    document.querySelectorAll(".sidebar_tags .slider-container").forEach(function (el) {
      el.classList.remove("sidebar-hidden");
    });
  }

  /** Re-run after inline `priceSlider()` / jRange builds markup. */
  function cabRevealPriceSliderAndResize() {
    ensureSliderVisible();
    if (window.jQuery) {
      try {
        window.jQuery(window).trigger("resize");
      } catch (_e) { /* ignore */ }
    }
  }

  var cabSidebarTogglePricePatched = false;
  /** Don’t let legacy `sidebarTogglePrice()` collapse the CAB price track (targets first slider in page). */
  function cabPatchSidebarTogglePriceForDrawer() {
    if (cabSidebarTogglePricePatched || typeof window.sidebarTogglePrice !== "function") return;

    cabSidebarTogglePricePatched = true;
    var original = window.sidebarTogglePrice;

    window.sidebarTogglePrice = function () {
      var btn = document.getElementById("pricearrowsToggle");
      if (btn && btn.closest(".sidebar_tags")) {
        cabRevealPriceSliderAndResize();
        btn.classList.toggle("active");
        return;
      }
      return original.apply(window, arguments);
    };
  }

  function scheduleCabPriceSliderReveal() {
    cabRevealPriceSliderAndResize();
    cabEnsurePriceSliderStep100Hooks();
    window.setTimeout(cabRevealPriceSliderAndResize, 120);
    window.setTimeout(cabRevealPriceSliderAndResize, 400);
    window.setTimeout(cabRevealPriceSliderAndResize, 800);
    window.setTimeout(cabEnsurePriceSliderStep100Hooks, 90);
    window.setTimeout(cabEnsurePriceSliderStep100Hooks, 450);
    window.setTimeout(cabEnsurePriceSliderStep100Hooks, 900);
  }

  /** Must match assets/theme.js collectionView: `change` on this selector → ajaxfilter. */
  var CAB_THEME_FACET_CHANGE_SEL = ".flForm .custCheck, .prRange, #SortBy";

  /**
   * theme.collectionView binds document-level `change` → ajaxfilter on every toggle.
   * For CAB we want batch UX: only ajaxfilter when the user clicks Apply.
   */
  function cabSuppressThemeImmediateFacetHandlers() {
    if (!window.jQuery) return;
    var $ = window.jQuery;
    $(document).off("change", ".optTag");
    /* ponytail: selector string must match theme.js exactly or `.off` is a no-op */
    $(document).off("change", CAB_THEME_FACET_CHANGE_SEL);
    /* Sort still applies immediately (toolbar #SortBySt delegates to #SortBy). */
    $(document).off("change.cabSortOnly", "#SortBy");
    $(document).on("change.cabSortOnly", "#SortBy", function () {
      var URL = "//" + window.location.hostname + window.location.pathname;
      var formdata = $("#CollectionFiltersForm").serialize();
      if (typeof window.ajaxfilter === "function") {
        window.ajaxfilter(URL + "?" + formdata);
      }
    });
  }

  /**
   * Theme priceSlider `ondragend` triggers `.original-filter` change → ajaxfilter.
   * CAB batch UX: mirror values only until Apply.
   */
  function cabPatchPriceSliderOndragendNoAjax() {
    if (!window.jQuery) return;
    var $rs = window.jQuery(".sidebar_tags .filterBox.flPrice input.range-slider").first();
    if (!$rs.length) return;
    var jr = $rs.data("plugin_jRange");
    if (!jr || !jr.options) return;
    jr.options.ondragend = function (value) {
      var values = String(value || "").split(",");
      var $ = window.jQuery;
      $('input[name="filter.v.price.gte"]').val(values[0]);
      $('input[name="filter.v.price.lte"]').val(values[1]);
      cabMirrorPriceInputsFromRangeSlider($rs[0]);
    };
  }

  /** Resolve facet chip href for ajaxfilter (handles https / protocol-relative / relative paths). */
  function cabActFilterHrefToAjaxUrl(href) {
    var h = String(href || "").trim();
    if (!h) return "";
    if (/^https?:\/\//i.test(h)) return h;
    if (/^\/\//.test(h)) return h;
    if (h.charAt(0) === "/") return "//" + window.location.hostname + h;
    return "//" + window.location.hostname + "/" + h.replace(/^\/+/, "");
  }

  /**
   * Liquid `| handleize` on chips (`data-value`) often differs from the URL tag segment
   * (e.g. `11-quot-x-14-quot` vs `11-x-14`).
   */
  function cabTagHandleCompareKey(raw) {
    return String(raw || "")
      .trim()
      .toLowerCase()
      .replace(/quot/g, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/-+/g, "-")
      .replace(/^-|-$/g, "");
  }

  function cabTagsMatchForRemoval(a, b) {
    var ka = cabTagHandleCompareKey(a);
    var kb = cabTagHandleCompareKey(b);
    return ka.length > 0 && kb.length > 0 && ka === kb;
  }

  /** `/collections/base/tag1+tag2`: drop one tag segment and ajaxfilter (when drawer checkbox sync fails). */
  function cabAjaxRemoveLegacyTagFromPath(chipDataValue) {
    var ajax = typeof window.ajaxfilter === "function" ? window.ajaxfilter : null;
    if (!ajax || !window.jQuery || !chipDataValue) return false;

    var needle = String(chipDataValue).trim();
    if (!needle) return false;

    var raw = window.jQuery(".sidebar_tags").attr("data-url") || "";
    if (!raw) return false;

    var baseA = document.createElement("a");
    baseA.href = raw;
    var collPath = String(baseA.pathname || "").replace(/\/+$/, "").replace(/^\/+/, "");
    collPath = "/" + collPath;

    var lp = String(window.location.pathname || "").replace(/\/+$/, "");
    var collNorm = collPath.replace(/\/+$/, "");

    if (lp !== collNorm && lp.indexOf(collNorm + "/") !== 0) return false;
    var tailEncoded = lp === collNorm ? "" : lp.slice(collNorm.length + 1);
    if (!tailEncoded) return false;

    var encParts = tailEncoded.split("+").filter(Boolean);
    var kept = [];
    var removed = false;

    for (var i = 0; i < encParts.length; i++) {
      var enc = encParts[i];
      var dec = enc;
      try {
        dec = decodeURIComponent(enc.replace(/\+/g, "%20"));
      } catch (_e) {
        /* ignore */
      }

      if (cabTagsMatchForRemoval(dec, needle) || cabTagsMatchForRemoval(enc, needle)) {
        removed = true;
        continue;
      }
      kept.push(enc);
    }

    if (!removed) return false;

    var path = "//" + window.location.hostname + collNorm;
    if (kept.length) path += "/" + kept.join("+");
    path += window.location.search || "";
    ajax(path);
    return true;
  }

  /**
   * CAB removes facet `change` → ajaxfilter; toolbar chips relied on that path.
   * Replace theme `document` delegates with CAB handlers + quot-aware tag matching.
   */
  function cabReplaceThemeToolbarFacetRemovalDelegation() {
    if (!window.jQuery) return;
    var $ = window.jQuery;

    $(document).off("click", "a.actFilter");
    $(document).off("click", "span.actFilter");
    $(document).off("click.cabToolbarFacet");

    $(document).on("click.cabToolbarFacet", ".active-facets a.actFilter", function cabAnchActFilter(ev) {

      var $el = $(this);
      if ($el.closest(".sidebar_tags").length) return;

      var rawHref = $el.attr("href");
      if (!rawHref || rawHref.charAt(0) === "#") return;

      ev.preventDefault();

      var ajax = typeof window.ajaxfilter === "function" ? window.ajaxfilter : null;
      if (!ajax) {
        window.location.href = rawHref;
        return;
      }
      ajax(cabActFilterHrefToAjaxUrl(rawHref));
    });

    $(document).on("click.cabToolbarFacet", ".active-facets span.actFilter", function cabSpanActFilter(ev) {

      var $chip = $(this);
      if ($chip.hasClass("js-facet-remove")) return;
      if ($chip.closest(".sidebar_tags").length) return;

      var fvRaw = $chip.attr("data-value");
      if (!fvRaw) return;

      ev.preventDefault();

      var $matches = $(".sidebar_tags input[type=\"checkbox\"]").filter(function () {
        return cabTagsMatchForRemoval(String($(this).val() || ""), fvRaw);
      });

      if ($matches.length) {
        $matches.prop("checked", false);
        cabRunFilterAjaxFromDrawerState();
        return;
      }

      if (!cabAjaxRemoveLegacyTagFromPath(fvRaw)) {
        var base = $(".sidebar_tags").attr("data-url") || "";
        window.location.href = base ? base + (window.location.search || "") : window.location.href;
      }
    });
  }

  function cabScheduleToolbarFacetRebind() {
    if (!window.jQuery) return;
    var tries = 0;
    function tick() {
      cabReplaceThemeToolbarFacetRemovalDelegation();
      tries++;
      if (tries < 15) window.setTimeout(tick, 100);
    }
    tick();
  }

  function cabParsePriceNum(v) {
    if (v === null || v === undefined) return null;
    var s = String(v).trim();
    if (s === "") return null;
    var n = parseFloat(s.replace(/,/g, ""));
    return isNaN(n) ? null : n;
  }

  /**
   * Ensure jRange uses CAB_PRICE_STEP so **slider dragging** snaps to $100; does not constrain typed min/max inputs.
   */
  function cabApplyJRangePriceStep100() {
    if (!window.jQuery) return;
    var $rs = window.jQuery(".sidebar_tags .filterBox.flPrice input.range-slider").first();
    if (!$rs.length) return;
    var jr = $rs.data("plugin_jRange");
    if (!jr || !jr.options) return;
    if (jr.options.step !== CAB_PRICE_STEP) jr.options.step = CAB_PRICE_STEP;
    try {
      if (typeof jr.render === "function") jr.render();
    } catch (_e1) { /* ignore */ }
    try {
      if (typeof jr.setValue === "function") jr.setValue($rs.val());
    } catch (_e2) { /* ignore */ }
  }

  var cabPriceSliderWrappedForStep100 = false;
  /** Wrap global `priceSlider()` so CAB can set jRange.step after theme (step:1) inits plugin. */
  function cabWrapPriceSliderForStep100Once() {
    if (cabPriceSliderWrappedForStep100) return false;
    if (typeof window.priceSlider !== "function") return false;
    cabPriceSliderWrappedForStep100 = true;
    var orig = window.priceSlider;
    window.priceSlider = function () {
      var ret = orig.apply(window, arguments);
      window.setTimeout(function () {
        cabApplyJRangePriceStep100();
        cabPatchPriceSliderOndragendNoAjax();
      }, 0);
      return ret;
    };
    return true;
  }

  function cabEnsurePriceSliderStep100Hooks() {
    cabWrapPriceSliderForStep100Once();
    cabApplyJRangePriceStep100();
    window.setTimeout(cabApplyJRangePriceStep100, 0);
    window.setTimeout(cabApplyJRangePriceStep100, 80);
    window.setTimeout(cabApplyJRangePriceStep100, 260);
    window.setTimeout(cabApplyJRangePriceStep100, 620);
  }

  /**
   * Min/Max fields in `.filterDD` live OUTSIDE `#CollectionFiltersForm`; only hidden `.original-filter`
   * inputs are serialized. Mirror drawer values → form + sync jRange (`input.range-slider`).
   * CAB: typed min/max accept any numeric value (clamped); jRange retains `step: 100` for handle movement only.
   */
  function cabApplyDrawerPricesToFormAndSlider() {
    if (!window.jQuery) return;
    var $ = window.jQuery;

    var $box = $(".sidebar_tags .filterBox.flPrice");
    if (!$box.length) return;

    var $dd = $box.find(".filterDD");
    if (!$dd.length) return;

    var $gteVis = $dd.find('input[name="filter.v.price.gte"]').first();
    var $lteVis = $dd.find('input[name="filter.v.price.lte"]').first();

    var gte = cabParsePriceNum($gteVis.val());
    var lte = cabParsePriceNum($lteVis.val());

    var maxCeil = cabParsePriceNum($lteVis.attr("max"));
    var floor = cabParsePriceNum($gteVis.attr("min"));
    if (floor === null) floor = 0;
    function clampIntoRange(g, l) {
      if (maxCeil !== null) {
        if (g !== null) g = Math.min(Math.max(g, floor), maxCeil);
        if (l !== null) l = Math.min(Math.max(l, floor), maxCeil);
      } else {
        if (g !== null) g = Math.max(g, floor);
        if (l !== null) l = Math.max(l, floor);
      }
      if (g !== null && l !== null && g > l) {
        var swap = g;
        g = l;
        l = swap;
        $gteVis.val(String(Math.round(g)));
        $lteVis.val(String(Math.round(l)));
      }
      return { g: g, l: l };
    }

    var cl = clampIntoRange(gte, lte);
    gte = cl.g !== null ? Math.round(cl.g) : null;
    lte = cl.l !== null ? Math.round(cl.l) : null;

    if (gte !== null && lte !== null && gte > lte) {
      var tb = gte;
      gte = lte;
      lte = tb;
    }

    var $gteForm = $('#CollectionFiltersForm input[name="filter.v.price.gte"].original-filter');
    var $lteForm = $('#CollectionFiltersForm input[name="filter.v.price.lte"].original-filter');

    if (gte !== null && $gteVis.length) {
      $gteVis.val(String(gte));
    }
    if (lte !== null && $lteVis.length) {
      $lteVis.val(String(lte));
    }

    if (gte !== null && $gteForm.length) {
      $gteForm.val(String(gte));
    }
    if (lte !== null && $lteForm.length) {
      $lteForm.val(String(lte));
    }

    var gEff = cabParsePriceNum($gteForm.length ? $gteForm.val() : null);
    var lEff = cabParsePriceNum($lteForm.length ? $lteForm.val() : null);
    if (gEff === null) gEff = 0;
    if (lEff === null && maxCeil !== null) lEff = maxCeil;

    if (gEff !== null && lEff !== null && gEff > lEff) {
      var zp = gEff;
      gEff = lEff;
      lEff = zp;
      if ($gteForm.length) $gteForm.val(String(gEff));
      if ($lteForm.length) $lteForm.val(String(lEff));
      if ($gteVis.length) $gteVis.val(String(gEff));
      if ($lteVis.length) $lteVis.val(String(lEff));
    }

    var $rs = $box.find("input.range-slider").first();
    if (!$rs.length || lEff === null) {
      try {
        $(window).trigger("resize");
      } catch (_eResize) {}
      return;
    }

    var pair = String(Math.round(gEff)) + "," + String(Math.round(lEff));
    $rs.val(pair);

    var jr = $rs.data("plugin_jRange");
    if (jr) {
      jr.options.step = CAB_PRICE_STEP;
      try {
        if (typeof jr.setValue === "function") {
          jr.setValue(pair);
        }
      } catch (_e2) {}
      try {
        if (typeof jr.render === "function") jr.render();
      } catch (_e3) {}
    }
    try {
      $(window).trigger("resize");
    } catch (_e4) {}
  }

  /** Run after inline / AJAX `priceSlider()` rebuilds jRange from stale markup */
  function scheduleCabDrawerPriceSyncAfterPlugins() {
    cabApplyDrawerPricesToFormAndSlider();
    window.setTimeout(cabApplyDrawerPricesToFormAndSlider, 140);
    window.setTimeout(cabApplyDrawerPricesToFormAndSlider, 380);
  }

  var cabDrawerPriceDelegatesBound = false;
  /** Keep hidden form + slider aligned when user edits Min/Max in the CAB drawer manually. */
  function cabBindDrawerPriceInputsSync() {
    if (!window.jQuery || cabDrawerPriceDelegatesBound) return;
    cabDrawerPriceDelegatesBound = true;
    var $ = window.jQuery;

    $(document).on(
      "input change blur",
      ".sidebar_tags .filterBox.flPrice .filterDD input.prRange",
      function () {
        cabApplyDrawerPricesToFormAndSlider();
      }
    );
  }

  var cabRangeSliderMirrorBound = false;
  /**
   * Theme jRange only assigns Min/Max in `ondragend` — values stay stale until mouseup.
   * jRange writes the hidden `input.range-slider` and fires `change` while dragging — mirror those into visible + original-filter inputs.
   */
  function cabMirrorPriceInputsFromRangeSlider(hiddenEl) {
    if (!window.jQuery || !hiddenEl) return;
    var $ = window.jQuery;
    var $hid = $(hiddenEl);
    var raw = String($hid.val() || "").trim();
    var parts = raw.split(",");
    if (parts.length < 2) return;

    var lo = String(parts[0]).trim();
    var hi = String(parts[1]).trim();

    var $box = $hid.closest(".filterBox.flPrice");
    if (!$box.length) return;
    var $dd = $box.find(".filterDD");
    if (!$dd.length) return;

    $dd.find('input[name="filter.v.price.gte"]').first().val(lo);
    $dd.find('input[name="filter.v.price.lte"]').first().val(hi);

    $('#CollectionFiltersForm input[name="filter.v.price.gte"].original-filter').first().val(lo);
    $('#CollectionFiltersForm input[name="filter.v.price.lte"].original-filter').first().val(hi);
  }

  function cabBindHiddenRangeSliderLiveMirror() {
    if (!window.jQuery || cabRangeSliderMirrorBound) return;
    cabRangeSliderMirrorBound = true;
    window.jQuery(document).on(
      "change",
      ".sidebar_tags .filterBox.flPrice input.range-slider",
      function cabRangeSliderMirrorHandler() {
        cabMirrorPriceInputsFromRangeSlider(this);
      }
    );
  }

  var cabSingleFacetCheckboxBound = false;
  /** CAB only: only one facet option checked at a time inside each facet list (within that filter row). Price skipped. */
  function cabBindSingleChoicePerFacetList() {
    if (!window.jQuery || cabSingleFacetCheckboxBound) return;
    cabSingleFacetCheckboxBound = true;
    window.jQuery(document).on(
      "change",
      ".sidebar_tags .filterBox:not(.flPrice) input[type=\"checkbox\"]",
      function cabSingleFacetHandler() {
        var $t = window.jQuery(this);
        var $box = $t.closest(".filterBox");
        if (!$box.length || $box.hasClass("flPrice")) return;
        if (!$t.is(":checked")) return;
        var $ul = $t.closest("ul");
        if (!$ul.length) return;
        $ul.find('input[type="checkbox"]').each(function () {
          var $cb = window.jQuery(this);
          if ($cb[0] !== $t[0] && $cb.is(":checked")) {
            $cb.prop("checked", false);
          }
        });
      }
    );
  }

  /** Same GET URL logic as assets/theme.js; full navigation fallback if ajaxfilter missing. */
  function cabRunFilterAjaxFromDrawerState() {
    if (!window.jQuery) return;
    var $ = window.jQuery;

    cabApplyDrawerPricesToFormAndSlider();

    var $form = $("#CollectionFiltersForm");
    var formQs = $form.length ? $form.serialize() : "";
    var paramString = window.location.search.substring(1);
    var mergedQs = formQs && paramString ? formQs + "&" + paramString : formQs || paramString;
    var dataUrl = $(".sidebar_tags").attr("data-url") || "";
    var newTags = [];
    $("input.optTag").each(function () {
      var $inp = $(this);
      if ($inp.val() && $inp.is(":checked")) {
        newTags.push(String($inp.val()));
      }
    });

    var url;
    if (dataUrl) {
      if (newTags.length) {
        url = dataUrl + "/" + newTags.join("+") + "?" + mergedQs;
      } else {
        url = dataUrl + "?" + mergedQs;
      }
    } else {
      url = "//" + window.location.hostname + window.location.pathname + "?" + mergedQs;
    }

    var ajax = window.ajaxfilter;
    if (typeof ajax === "function") {
      ajax(url);
    } else {
      window.location.href = url;
    }
  }

  function cabSearchHasFilterParams(searchRaw) {
    var q = String(searchRaw || "").replace(/^\?/, "");
    if (!q) return false;
    var sp;
    try {
      sp = new URLSearchParams(q);
    } catch (_e) {
      return false;
    }
    var has = false;
    sp.forEach(function (_value, key) {
      if (has) return;
      if (String(key).indexOf("filter.") === 0) has = true;
    });
    return has;
  }

  /** Tag-style filters extend the path with extra segments after collection base (`data-url` pathname). */
  function cabCollectionPathHasAppliedTagSegments() {
    var raw = "";
    var st = document.querySelector(".sidebar_tags");
    if (st && st.getAttribute) raw = String(st.getAttribute("data-url") || "").trim();
    if (!raw) return false;
    try {
      var baseA = document.createElement("a");
      baseA.href = raw;
      var basePath = String(baseA.pathname || "").replace(/^\/+|\/+$/g, "");
      var locPath = String(window.location.pathname || "").replace(/^\/+|\/+$/g, "");
      if (!basePath) return false;

      function segs(abs) {
        return abs.split("/").filter(function (s) {
          return s.length;
        });
      }
      var b = segs(basePath);
      var l = segs(locPath);
      if (l.length <= b.length) return false;
      for (var i = 0; i < b.length; i++) {
        if (b[i] !== l[i]) return false;
      }
      return true;
    } catch (_e2) {
      return false;
    }
  }

  /**
   * True when filters are already reflected in the location (matches server / PushState after Apply).
   * Pending drawer edits are not visible here until Apply; Clear then only resets the form DOM.
   */
  function cabAppliedFiltersReflectInLocation() {
    return cabSearchHasFilterParams(window.location.search) || cabCollectionPathHasAppliedTagSegments();
  }

  function cabResetDrawerToLastServerRender() {
    var form = document.getElementById("CollectionFiltersForm");
    if (form && typeof form.reset === "function") {
      form.reset();
    }

    /**
     * Theme closes `#CollectionFiltersForm` before `.filterDD` / `.range-slider` and tag `optTag` rows,
     * so reset() alone does not uncheck tags or revert visible price fields. When no filters are applied
     * in the URL, defaults are unchecked facets + hidden original price defaults.
     */
    if (window.jQuery) {
      var $ = window.jQuery;
      $(".sidebar_tags input[type=\"checkbox\"]").each(function () {
        if (form && !form.contains(this)) {
          this.checked = false;
        }
      });

      var $gteOrig = $("#CollectionFiltersForm input[name=\"filter.v.price.gte\"].original-filter").first();
      var $lteOrig = $("#CollectionFiltersForm input[name=\"filter.v.price.lte\"].original-filter").first();
      var $priceBox = $(".sidebar_tags .filterBox.flPrice");
      if ($priceBox.length && $gteOrig.length && $lteOrig.length) {
        var gv = String($gteOrig.val() || "").trim();
        var lv = String($lteOrig.val() || "").trim();
        $priceBox.find(".filterDD input[name=\"filter.v.price.gte\"]").first().val(gv);
        $priceBox.find(".filterDD input[name=\"filter.v.price.lte\"]").first().val(lv);

        var gNum = cabParsePriceNum(gv);
        var lNum = cabParsePriceNum(lv);
        if (gNum !== null && lNum !== null) {
          var pair = String(Math.round(gNum)) + "," + String(Math.round(lNum));
          $priceBox.find("input.range-slider").first().val(pair);
        }
      }
    }

    if (typeof window.priceSlider === "function") {
      try {
        window.priceSlider();
      } catch (_ps) {}
    }
    cabApplyDrawerPricesToFormAndSlider();
    scheduleCabPriceSliderReveal();
  }

  /** CAB: Material facet shows only these options (canonical keys = normalized lowercase). */
  var CAB_MATERIAL_KEYS_ORDER = ["pewter", "silver plated", "sterling silver", "sterling silver layer"];

  /**
   * @param {string} rawLabel
   * @returns {string | null}
   */
  function cabMaterialKeyFromLabel(rawLabel) {
    var n = String(rawLabel || "")
      .replace(/\(\s*\d+\s*\)/g, "")
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();
    if (!n) return null;
    if (n === "sterling silver layer") return "sterling silver layer";
    if (n === "silver plated") return "silver plated";
    if (n === "sterling silver") return "sterling silver";
    if (n === "pewter") return "pewter";
    return null;
  }

  /**
   * Remove any Material facet options not in CAB_MATERIAL_KEYS_ORDER and reorder DOM to match design order.
   */
  function cabPruneMaterialFacetForCab() {

    document.querySelectorAll(".sidebar_tags .filterBox:not(.flPrice)").forEach(function (box) {
      var titleEl = box.querySelector("a.widget-title, .widget-title");
      if (!titleEl) return;
      var titleText = String(titleEl.textContent || "")
        .replace(/\([^)]*\)/g, "")
        .replace(/\s+/g, " ")
        .trim();
      if (!/material/i.test(titleText)) return;

      var ul = box.querySelector("ul.widget-content.flOpt, ul.flOpt");
      if (!ul || !ul.querySelectorAll) return;

      var byKey = {};
      ul.querySelectorAll(":scope > li").forEach(function (li) {
        var lab = li.querySelector("label");
        if (!lab) {
          li.remove();
          return;
        }
        var key = cabMaterialKeyFromLabel(lab.textContent || "");
        if (!key) {
          li.remove();
          return;
        }
        if (byKey[key]) {
          li.remove();
          return;
        }
        byKey[key] = li;
      });

      CAB_MATERIAL_KEYS_ORDER.forEach(function (key) {
        var liEl = byKey[key];
        if (!liEl) return;
        ul.appendChild(liEl);
      });
    });
  }

  /** Category-style facets (SidebarcontentflOpt lists): alphabetical A–Z by visible label — CAB only. */
  function cabAlphabetizeSidebarContentFacetLists() {

    document.querySelectorAll(".sidebar_tags ul.widget-content.SidebarcontentflOpt").forEach(function (ul) {
      var items = Array.prototype.slice.call(ul.querySelectorAll(":scope > li"));
      items.sort(function (a, b) {
        var la = a.querySelector("label");
        var lb = b.querySelector("label");
        var ta = la ? String(la.textContent || "") : "";
        var tb = lb ? String(lb.textContent || "") : "";
        ta = ta.replace(/\(\s*\d+\s*\)/g, "").replace(/\s+/g, " ").trim();
        tb = tb.replace(/\(\s*\d+\s*\)/g, "").replace(/\s+/g, " ").trim();
        return ta.localeCompare(tb, undefined, { sensitivity: "base" });
      });
      items.forEach(function (li) {
        ul.appendChild(li);
      });
    });
  }

  /** Inject " (FOR PICTURE FRAMES ONLY)" after Size label — CAB only; idempotent. */
  function cabInjectPictureFramesNoteIntoSizeTitle(a) {
    if (!a || !a.classList || !a.classList.contains("widget-title")) return;
    if (a.querySelector(".cab-v2-filter-size-label__main")) return;

    var labelText = "";
    var strip = [];
    var node = a.firstChild;
    while (node) {
      var nx = node.nextSibling;
      if (node.nodeType === 3) {
        labelText += node.nodeValue || node.textContent || "";
        strip.push(node);
        node = nx;
        continue;
      }
      if (node.nodeType === 1 && node.classList && node.classList.contains("count-bubble")) break;
      node = nx;
    }
    strip.forEach(function (t) {
      if (t.parentNode) t.parentNode.removeChild(t);
    });

    labelText = String(labelText || "").replace(/\s+/g, " ").trim();
    if (!labelText) labelText = "SIZE";

    var main = document.createElement("span");
    main.className = "cab-v2-filter-size-label__main";
    main.textContent = labelText.toUpperCase();

    var note = document.createElement("span");
    note.className = "cab-v2-filter-size-label__note";
    note.textContent = " (FOR PICTURE FRAMES ONLY)";

    var insertBeforeEl = a.querySelector(".count-bubble") ||
      a.querySelector("i.ad-angle-down-l") ||
      null;
    if (insertBeforeEl) {
      a.insertBefore(main, insertBeforeEl);
      a.insertBefore(note, insertBeforeEl);
    } else {
      a.appendChild(main);
      a.appendChild(note);
    }
  }

  /**
   * Size facet: theme adds `twoCall` on `ul.flOpt` when block marks filter as size.
   * Fallback: title text (before count bubble) is exactly "Size".
   */
  function cabAugmentSizeFacetTitleForDrawer() {

    document.querySelectorAll(".sidebar_tags .filterBox:not(.flPrice) ul.widget-content.flOpt.twoCall").forEach(function (_ul) {
      var box = _ul.closest(".filterBox");
      if (!box) return;
      cabInjectPictureFramesNoteIntoSizeTitle(box.querySelector("a.widget-title"));
    });

    document.querySelectorAll(".sidebar_tags .filterBox:not(.flPrice) a.widget-title").forEach(function (a) {
      if (a.querySelector(".cab-v2-filter-size-label__main")) return;
      var labelOnly = "";
      var node = a.firstChild;
      while (node) {
        if (node.nodeType === 3) labelOnly += node.nodeValue || "";
        else if (node.nodeType === 1 && node.classList && node.classList.contains("count-bubble")) break;
        node = node.nextSibling;
      }
      labelOnly = String(labelOnly || "").replace(/\s+/g, " ").trim();
      if (!/^size$/i.test(labelOnly)) return;
      cabInjectPictureFramesNoteIntoSizeTitle(a);
    });
  }

  function addMaterialInfoIcons() {
    var titles = document.querySelectorAll(".sidebar_tags .filterBox:not(.flPrice) .widget-title");
    titles.forEach(function (el) {
      var txt = (el.textContent || "").trim();
      if (!/material/i.test(txt)) return;
      if (el.querySelector(".cab-v2-filter-info-icon")) return;
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "cab-v2-filter-info-icon";
      btn.setAttribute("data-cab-v2-modal-open", "");
      btn.setAttribute("aria-label", "Material information — compare silver options");
      btn.setAttribute("title", "");
      btn.innerHTML = CAB_MATERIAL_INFO_SVG;
      el.appendChild(btn);
    });
  }

  function labelPriceMinMax() {
    var labels = document.querySelectorAll(".sidebar_tags .filterBox.flPrice .filterDD .field__label");
    if (labels.length < 2) return;
    labels[0].textContent = "Min";
    labels[1].textContent = "Max";
  }

  /** Price facet: placeholders, row order (slider → min/max — theme DOM unchanged). */
  function layoutPriceFacetForCab() {

    var box = document.querySelector(".sidebar_tags .filterBox.flPrice");
    if (!box) return;

    /* Theme can flag the price box `not-avail-on-this` (no <li> options); CAB CSS hides empties — keep price visible. */
    box.classList.remove("not-avail-on-this");
    box.classList.add("cab-v2-price-layout");
    var rng = box.querySelector("input.range-slider");
    if (rng && rng.parentElement) {
      rng.parentElement.classList.add("cab-v2-price-slider-host");
    }

    box.querySelectorAll(".prRange").forEach(function (inp) {
      inp.setAttribute("placeholder", "0");
      inp.removeAttribute("step");
      inp.setAttribute("inputmode", "numeric");
    });

    window.setTimeout(function () {
      if (window.jQuery) {
        try {
          window.jQuery(window).trigger("resize");
        } catch (_e) { /* ignore */ }
      }
    }, 120);
  }
/** Hide/show Shopify chat when drawer opens/closes */
  function toggleChatVisibility(isDrawerOpen) {
    var chat = document.querySelector("inbox-online-store-chat");
    if (chat) {
      chat.style.visibility = isDrawerOpen ? "hidden" : "visible";
    }
  }

  function toggleGoogleMerchantVisibility(isDrawerOpen) {
  var widget = document.getElementById("google-merchantwidget-iframe-wrapper");
  if (widget) {
    widget.style.visibility = isDrawerOpen ? "hidden" : "visible";
  }
}
  /* ASG-046-DI */
  function cabGetFilterOverlay() {
    var overlay = document.querySelector(".bg-overlayds");
    if (overlay && overlay.parentNode !== document.body) {
      document.body.appendChild(overlay);
    }
    return overlay;
  }

  function cabSetFilterDrawerOpen(isOpen) {
    document.documentElement.classList.toggle("cab-v2-filter-drawer--open", !!isOpen);
    document.body.classList.toggle("cab-v2-filter-drawer--open", !!isOpen);

    var overlay = cabGetFilterOverlay();
    if (!overlay) return;

    if (isOpen) {
      overlay.removeAttribute("hidden");
      overlay.setAttribute("aria-hidden", "false");
    } else {
      overlay.setAttribute("hidden", "");
      overlay.setAttribute("aria-hidden", "true");
    }
  }

  var cabOverlayCloseBound = false;
  function cabBindOverlayClose() {
    if (cabOverlayCloseBound) return;
    cabOverlayCloseBound = true;

    document.addEventListener("click", function (e) {
      if (!e.target || !e.target.closest) return;
      if (!e.target.closest(".bg-overlayds")) return;
      if (!document.documentElement.classList.contains("cab-v2-filter-drawer--open")) return;

      var close = document.querySelector(".sidebar_tags .close-btn-allfilter");
      if (close) close.click();

      var sidebar = document.querySelector(".sidebar_tags.main-all-d-none");
      if (sidebar) sidebar.classList.remove("active");
      document.querySelectorAll(".all-filter-collection").forEach(function (el) {
        el.classList.remove("active");
      });
      document.body.classList.remove("FDR-filters-open");
      cabSetFilterDrawerOpen(false);
    });
  }

  /** Monitor drawer open/close state */
  var cabDrawerStateWatched = false;
  function watchDrawerState() {
    /* `.sidebar_tags` persists across ajaxfilter (only innerHTML is swapped); bind once to avoid stacking observers. */
    if (cabDrawerStateWatched) return;
    var sidebar = document.querySelector(".sidebar_tags.main-all-d-none");
    if (!sidebar) {
      window.setTimeout(watchDrawerState, 150);
      return;
    }
    cabDrawerStateWatched = true;

    cabBindOverlayClose();
    cabSetFilterDrawerOpen(sidebar.classList.contains("active"));

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.attributeName === "class") {
          var isActive = sidebar.classList.contains("active");
          toggleChatVisibility(isActive);
          toggleGoogleMerchantVisibility(isActive);
          cabSetFilterDrawerOpen(isActive);
          if (isActive) cabRefreshPriceSliderOnOpen();
        }
      });
    });

    observer.observe(sidebar, { attributes: true });
  }
  function insertFooter(root) {
    if (!root || root.querySelector("." + FOOTER_CLASS)) return;

    var footer = document.createElement("div");
    footer.className = FOOTER_CLASS;
    footer.setAttribute("role", "group");

    var clearBtn = document.createElement("button");
    clearBtn.type = "button";
    clearBtn.className = "cab-v2-filter-btn cab-v2-filter-btn--clear";
    clearBtn.textContent = "Clear All";

    var applyBtn = document.createElement("button");
    applyBtn.type = "button";
    applyBtn.className = "cab-v2-filter-btn cab-v2-filter-btn--apply";
    applyBtn.textContent = "Apply";

    footer.appendChild(clearBtn);
    footer.appendChild(applyBtn);
    root.appendChild(footer);

    clearBtn.addEventListener("click", function (e) {
      e.preventDefault();
      if (!cabAppliedFiltersReflectInLocation()) {
        cabResetDrawerToLastServerRender();
        return;
      }

      var url = "";
      var st = document.querySelector(".sidebar_tags");
      if (st && st.getAttribute) {
        url = st.getAttribute("data-url") || "";
      }
      if (url) {
        window.location.href = url;
      } else {
        var path = window.location.pathname;
        window.location.href = path.split("?")[0];
      }
    });

    applyBtn.addEventListener("click", function (e) {
      e.preventDefault();
      cabRunFilterAjaxFromDrawerState();
      var close = document.querySelector(".sidebar_tags .close-btn-allfilter");
      if (close) {
        close.click();
      } else if (window.jQuery) {
        window.jQuery(".close-btn-allfilter").trigger("click");
      }
    });
  }

  /** jRange reads parent width once; keep `.slider-container` at full host width once (mark inputs so theme init doesn't clash). */
  function patchSliderWidths() {
    var containers = document.querySelectorAll(".sidebar_tags .slider-container");
    containers.forEach(function (c) {
      if (c.style) {
        c.style.width = "100%";
        c.style.maxWidth = "100%";
      }
    });
    var sliders = document.querySelectorAll(".sidebar_tags input.range-slider");
    sliders.forEach(function (inp) {
      if (inp.getAttribute && !inp.getAttribute("data-cab-v2-width-fixed")) {
        inp.setAttribute("data-cab-v2-width-fixed", "1");
      }
    });
  }

  /**
   * CAB only: legacy theme CSS keeps empty facet rows visible. Re-count options inside the CAB drawer and
   * sync `.not-avail-on-this` + `.main-all-title-is-not` (flOpt / clrFl / category sub-list included).
   */
  function cabMarkEmptyFacetBlocks() {
    if (!window.jQuery) return;
    var $ = window.jQuery;
    $(".sidebar_tags .under-to-allfilter-collection > .sidebar_widget.filterBox:not(.flPrice)").each(function (index) {
      var $this = $(this);
      var availnotlengt = $this.find(
        "ul.widget-content li, ul.flOpt li, ul.clrFl li, ul#collection_cat li"
      ).length;
      window.setTimeout(function () {
        if ($this.hasClass("not-avail-on-this")) {
          $(".main-all-title-is-not").eq(index).addClass("not-avail-on-this");
        } else {
          $(".main-all-title-is-not").eq(index).removeClass("not-avail-on-this");
        }
      }, 500);
      if (availnotlengt === 0) {
        $this.addClass("not-avail-on-this");
      } else {
        $this.removeClass("not-avail-on-this");
      }
    });
  }

  /** BA drawer only: remove "SHOPPING BY" active-chip block (duplicate UX vs CAB footer/chips elsewhere). */
  function hideCabShoppingByCrFilters() {
    document.querySelectorAll(".sidebar_tags .sidebar_widget.crFilters").forEach(function (el) {
      el.remove();
    });
  }

  /**
   * BA drawer only: remove the Availability facet (In stock / Out of stock).
   * Removing the node clears empty vertical gaps; CSS :has() hides it before JS where supported.
   */
  function hideCabAvailabilityFacets() {

    var form = document.getElementById("CollectionFiltersForm");
    if (!form || !document.querySelector(".sidebar_tags")) return;

    form.querySelectorAll(".sidebar_widget.filterBox").forEach(function (box) {
      if (!box.closest(".sidebar_tags")) return;

      var rm = !!box.querySelector('input[type="checkbox"][name*="availability"]');

      if (!rm) {
        var t = box.querySelector("a.widget-title, .widget-title");
        var lab = (t && t.textContent) ? (t.textContent || "").replace(/\s+/g, " ").trim() : "";
        lab = lab.replace(/\(\d*\)/g, "").trim().toLowerCase();
        if (lab === "availability") rm = true;
      }

      if (rm) {
        box.remove();
      }
    });
  }

  /**
   * True only when theme ajaxfilter swapped drawer markup (footer gone). Load-more ajax leaves
   * the drawer intact — footer still present → skip full reapply.
   */
  function cabDrawerNeedsReapply() {
    var shell = document.querySelector(".sidebar_tags .under-allfilter-collection");
    if (!shell) return false;
    return !shell.querySelector("." + FOOTER_CLASS);
  }

  var cabReapplyRunning = false;
  var cabSidebarObserver = null;
  var cabObservedSidebar = null;

  /* pause the swap observer while we mutate the drawer, so our own DOM writes
   * (footer insert, price layout, slider rebuild) never re-trigger reapply (avoids a loop). */
  function cabPauseSidebarObserver() {
    if (cabSidebarObserver) cabSidebarObserver.disconnect();
  }
  function cabResumeSidebarObserver() {
    if (cabSidebarObserver && cabObservedSidebar) {
      cabSidebarObserver.observe(cabObservedSidebar, { childList: true, subtree: true });
    }
  }

  /** Re-apply CAB drawer chrome after theme ajaxfilter replaces `.sidebar_tags` inner HTML. */
  function cabReapplyAfterAjax() {
    if (cabReapplyRunning) return;

    if (!cabDrawerNeedsReapply()) {
      cabApplyDrawerPricesToFormAndSlider();
      return;
    }

    cabReapplyRunning = true;
    cabPauseSidebarObserver();
    try {
      cabSuppressThemeImmediateFacetHandlers();
      cabScheduleToolbarFacetRebind();
      cabApplyDrawerChrome();
      if (typeof window.priceSlider === "function") {
        try {
          window.priceSlider();
        } catch (_err) { /* ignore */ }
      }
      cabPatchPriceSliderOndragendNoAjax();
      ensureSliderVisible();
      patchSliderWidths();
      scheduleCabPriceSliderReveal();
      labelPriceMinMax();
      cabEnsurePriceSliderStep100Hooks();
      scheduleCabDrawerPriceSyncAfterPlugins();
      cabApplyDrawerPricesToFormAndSlider();
      window.setTimeout(cabMarkEmptyFacetBlocks, 120);
    } finally {
      cabReapplyRunning = false;
      cabResumeSidebarObserver();
    }
  }

  /**
   * Robust swap detection: the theme loads two jQuery instances (local + googleapis CDN), so a
   * jQuery `ajaxComplete` hook may bind to a different jQuery than the one running `ajaxfilter`.
   * A native MutationObserver on `.sidebar_tags` catches the inner-HTML swap regardless.
   */
  function cabStartSidebarObserver() {
    var sidebar = document.querySelector(".sidebar_tags");
    if (!sidebar) {
      window.setTimeout(cabStartSidebarObserver, 150);
      return;
    }
    if (cabObservedSidebar === sidebar && cabSidebarObserver) return;
    if (cabSidebarObserver) cabSidebarObserver.disconnect();
    cabObservedSidebar = sidebar;
    cabSidebarObserver = new MutationObserver(function () {
      if (cabReapplyRunning) return;
      if (!cabDrawerNeedsReapply()) return;
      cabReapplyAfterAjax();
    });
    cabSidebarObserver.observe(sidebar, { childList: true, subtree: true });
  }

  /** Shared CAB drawer setup: footer, price layout, facet tweaks (init + post-ajax). */
  function cabApplyDrawerChrome() {

    hideCabShoppingByCrFilters();
    cabPatchSidebarTogglePriceForDrawer();
    cabSuppressThemeImmediateFacetHandlers();
    cabScheduleToolbarFacetRebind();
    cabPruneMaterialFacetForCab();
    cabAlphabetizeSidebarContentFacetLists();
    cabAugmentSizeFacetTitleForDrawer();

    var shell = document.querySelector(".sidebar_tags .under-allfilter-collection");
    if (!shell) return;

    hideCabAvailabilityFacets();
    replaceCloseIcon();
    layoutPriceFacetForCab();
    ensureSliderVisible();
    patchSliderWidths();
    scheduleCabPriceSliderReveal();
    labelPriceMinMax();
    addMaterialInfoIcons();
    insertFooter(shell);
    cabBindDrawerPriceInputsSync();
    cabBindHiddenRangeSliderLiveMirror();
    cabBindSingleChoicePerFacetList();
  }

  /**
   * jRange caches its track width from `domNode.parent().width()`. The Apply button closes the
   * drawer right after firing the ajax, so when the filter response lands and the slider (re)builds,
   * the drawer is hidden (width 0) and the track renders empty — it looks "gone" on reopen. Trigger
   * the jRange window-resize re-measure once the drawer is actually visible again.
   */
  function cabRefreshPriceSliderOnOpen() {
    ensureSliderVisible();
    function remeasure() {
      if (window.jQuery) {
        try {
          window.jQuery(window).trigger("resize");
        } catch (_e) { /* ignore */ }
      }
      cabApplyJRangePriceStep100();
    }
    remeasure();
    window.setTimeout(remeasure, 60);
    window.setTimeout(remeasure, 220);
  }

  function init() {

    if (typeof window.cabV2WireSilverModalOnce === "function") {
      window.cabV2WireSilverModalOnce();
    }

    window.setTimeout(cabSuppressThemeImmediateFacetHandlers, 0);
    window.setTimeout(cabSuppressThemeImmediateFacetHandlers, 400);

    cabApplyDrawerChrome();
    cabApplyDrawerPricesToFormAndSlider();
    scheduleCabDrawerPriceSyncAfterPlugins();
    window.setTimeout(cabMarkEmptyFacetBlocks, 150);
    watchDrawerState();
    cabStartSidebarObserver();
  }

  var cabBootstrapped = false;
  function cabStart() {
    if (cabBootstrapped) return;
    cabBootstrapped = true;
    init();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", cabStart);
  } else {
    cabStart();
  }

  if (window.jQuery) {
    window.jQuery(document).ajaxComplete(function () {
      cabStart();
      cabReapplyAfterAjax();
    });
  }
})();
